/**
 * Collection of generic label values
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/labelValue';

class LabelValues extends Base {
	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/**
	 * getProperty returns a value by label, unpacking the LVB.
	 * @method
	 * @param {string} label Full name of a property
	 * @return string or undefined
	 */
	getProperty(label) {
		const lvb = this.findWhere({label: label});
		return lvb ? lvb.get('value') : undefined;
	}

	/**
	 *
	 * To test the boolean truth of properties that can contain the string "true" or "false",
	 * we sometimes want to return true only if the string is "true" ... any other string == false.
	 * Other times, we want the opposite.  And you never know when someone might have made a typo,
	 * since it's a text field ... isTrue and isFalse simplify that.
	 * @param string label full name of a property
	 * @returns boolean
	 *
	 */
	isTrue(label) {
		return this.getProperty(label) === 'true';
	}
	isFalse(label) {
		return this.getProperty(label) === 'false';
	}

	/** @type {string} */
	static get __name__() {
		return 'LabelValues';
	}
}

export default LabelValues;
